<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center" id="formWrapper">
        <v-col cols="12" sm="8" md="4">
          <img :src="logoUrl" id="logo" />
          <v-card id="loginCard">
            <v-card-text>
              <v-container v-if="!isError && !activated">
                <v-form
                  name="activateform"
                  @submit.prevent="login"
                  v-model="formValid"
                >
                  <div>
                    <h2>Hallo {{ user ? user.firstname : "" }}</h2>
                    Um dein Konto zu aktivieren setze dir bitte ein Passwort und
                    bestätige unsere AGBs.
                  </div>
                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="password"
                    :rules="[rules.required, rules.min]"
                  />

                  <v-text-field
                    id="passwordconfirm"
                    label="Password bestätigen"
                    name="passwordconfirm"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="passwordconfirm"
                    :rules="[rules.required, passwordConfirmationRule]"
                  />
                  <div>Die AGBs findest du hier</div>
                  <v-switch
                    v-model="acceptAGB"
                    color="green"
                    label="AGBs akzeptieren"
                    :rules="[rules.required]"
                  />
                </v-form>
              </v-container>
              <v-container v-else-if="!isError && activated">
                <v-alert type="success" color="green" border="top">
                  <p>
                    Vielen Dank!<br />
                    Dein Zugang wurde aktiviert!
                  </p>
                  <div>
                    <a :href="redirectURL" style="color: #fff"
                      >Klicke hier um dich anzumelden</a
                    >
                  </div>
                </v-alert>
              </v-container>
              <v-container v-else>
                <v-alert type="error" color="red" border="top">
                  Leider ist ein Fehler aufgetreten, dein Aktivierungstoken
                  wurde nicht gefunden!
                </v-alert>
              </v-container>
            </v-card-text>
            <v-card-actions v-if="!isError && !activated">
              <v-spacer />
              <v-btn
                block
                color="success"
                @click="save"
                name="submit"
                type="submit"
                :disabled="!formValid"
                >Aktivierung abschließen</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  name: "Activation",
  data: () => ({
    token: null,
    isError: false,
    activated: false,
    password: "",
    passwordconfirm: "",
    acceptAGB: false,
    formValid: false,
    rules: {
      required: (value) => !!value || "Dieses Feld wird benötigt!.",
      min: (v) => v.length >= 8 || "mind. 8 Zeichen",
    },

    user: null,
  }),

  computed: {
    logoUrl() {
      return `${process.env.VUE_APP_API_URL}/ressources/images/logo.png`;
    },
    redirectURL() {
      return process.env.VUE_APP_FRONTEND_URL;
    },
    passwordConfirmationRule() {
      return () =>
        this.password === this.passwordconfirm ||
        "Die Passwörter stimmen nicht überein";
    },
  },

  methods: {
    save() {
      if (!this.formValid) {
        this.$notify({
          group: "dataline",
          type: "error",
          title: "Aktivierungsfehler",
          text: "Formular unvollständig",
        });
        return false;
      }
      UserService.activateUser({
        token: this.token,
        password: this.password,
        passwordConfirm: this.passwordconfirm,
        acceptagb: this.acceptAGB,
      })
        .then(() => {
          this.activated = true;
          // this.$router.push("/dashboard");
        })
        .catch((error) => {
          const msg =
            error.response && error.response.data
              ? error.response.data.error
              : error.message;
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Aktivierungsfehler",
            text: msg,
          });
        });
    },
  },
  beforeCreate() {
    this.$store.commit("user/LOGOUT");
  },
  created() {
    this.token = this.$route.params.token;

    UserService.fetchByActivationToken(this.token)
      .then((result) => {
        this.user = result.data.data;
      })
      .catch((error) => {
        this.isError = true;
        console.log(error);
      });
  },
};
</script>

<style scoped>
#formWrapper {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 20px 0px 100px 0px;
  margin-top: 100px;
  transform: skewY(-2deg);
  text-align: center;
}
#loginCard {
  transform: skewY(2deg);
}

#logo {
  width: 150px;
  margin-top: -110px;
  margin-bottom: 50px;
}
</style>
